import React, { useState, useEffect } from "react";
import {
  TriangleAlert,
  MessageSquare,
  Bell,
  TrendingUp,
  TrendingDown,
  ChevronLeft,
} from "lucide-react";
import MISnavbar from "../Navbar/MISnavbar";
import DisbursalTracking from "./Disbursal Tracking/Disbursaltracking";
import FunnelVisualization from "../Funnel Visualization/Funnelvisualization";
import { dummyData, getDataForMonth } from "../Dummydata/dummydata";
import Financial from "../Financial Summary/Financial";
import EmiBehavour from "../Emi-behaviour/EmiBehavour";
import ProjectVSActual from "../project vs actul/ProjectVSActual";
import { getOverdueSummary } from "../API's/Actioncreator";
import "../style/mis.scss";
import CommonPanel from "../common/CommonPannel";
import CustomDateScroll from "../common/CustomDateScroll";
// import Loader from '../../../Component/Common/Loader.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import StyledTooltip from '../common/StyledTooltip'
import DateFilterSelect from '../../../../CustomDatePicker/DateFilterSelectold'
import moment from "moment";
import { APIS } from "../../../../../utils/api-factory";


const getCurrentMonth = () => {
  const date = new Date();
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const currentMonth = monthNames[date.getMonth()];
  const currentYear = date.getFullYear();
  return `${currentMonth} ${currentYear}`;
};

const getCurrentMonthRange = (type) => {
  const now = moment();

  const start = now.clone().startOf("month");
  const end = now.clone().endOf("month");

  if (type === "fromDate") {
    return start.format("YYYY-MM-DD");
  }

  if (type === "toDate") {
    return end.format("YYYY-MM-DD");
  }

  return "";
};

export default function FinancialMis({ admin, pageViewHandler }) {
  const [selectedMonths, setSelectedMonths] = useState([getCurrentMonth()]);
  const [loader, setLoader] = useState(false)
  const [selectedView, setSelectedView] = useState("disbursal");
  const [tags, setTags] = useState({ 0: [], 1: [] });
  const [tagInputs, setTagInputs] = useState({ 0: "", 1: "" });
  const [activePanel, setActivePanel] = useState(null);
  const [comments, setComments] = useState([]);
  const [reminders, setReminders] = useState([]);
  const [alertsNotes, setAlertsNotes] = useState([]);
  const [overdueSummaryData, setOverdueSummaryData] = useState(null);
  const [commonFilter, setcommonFilter] = useState({ fromDate: getCurrentMonthRange("fromDate"), toDate: getCurrentMonthRange("toDate"), nbfc: "" });
  const [SelectedMonthsFromDate, setSelectedMonthstoDate] = useState({ fromDate: getCurrentMonthRange("fromDate"), toDate: getCurrentMonthRange("toDate"), nbfc: "" });
  const [nbfcData, setnbfcData] = useState([])

  useEffect(() => {
    const getNbfcList = () => {
      fetch(APIS.GET_LIST_OF_NBFC)
        .then(res => res.json())
        .then(res => {
          setnbfcData(res)

        })
    }
    getNbfcList()
  }, [])

  useEffect(() => {
     getOverdueSummary(moment(commonFilter?.fromDate).format("DD-MM-YYYY"), moment(commonFilter?.toDate).format("DD-MM-YYYY"),commonFilter?.nbfc ?? "", response=>{
      if (response?.status == 200 && response?.message == "success") {
            setOverdueSummaryData(response);
          } else {
            setOverdueSummaryData(null)
          }
     });
  }, [commonFilter?.nbfc])



  // Fetch overdue summary data when selectedMonth changes
  useEffect(() => {
    if (selectedMonths.length > 0) {
      const monthMap = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3,
        May: 4, Jun: 5, Jul: 6, Aug: 7,
        Sep: 8, Oct: 9, Nov: 10, Dec: 11
      };

      const sortedMonths = [...selectedMonths].sort((a, b) => {
        const [monthA, yearA] = a.split(" ");
        const [monthB, yearB] = b.split(" ");

        const dateA = new Date(yearA, monthMap[monthA]);
        const dateB = new Date(yearB, monthMap[monthB]);

        return dateA - dateB;
      });


      const [startMonthName, startYear] = sortedMonths[0].split(" ");
      const startMonthIndex = monthMap[startMonthName];


      const [endMonthName, endYear] = sortedMonths[sortedMonths.length - 1].split(" ");
      const endMonthIndex = monthMap[endMonthName];


      const startDate = `01-${String(startMonthIndex + 1).padStart(2, "0")}-${startYear}`;


      const lastDay = new Date(endYear, endMonthIndex + 1, 0).getDate();
      const endDate = `${lastDay}-${String(endMonthIndex + 1).padStart(2, "0")}-${endYear}`;

      setcommonFilter({ fromDate: moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD"), toDate: moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD") })
      setSelectedMonthstoDate({ fromDate: moment(startDate, "DD-MM-YYYY").format("YYYY-MM-DD"), toDate: moment(endDate, "DD-MM-YYYY").format("YYYY-MM-DD") })

      setLoader(true)
      // Fetch overdue summary data
      new Promise((resolve, reject) => {
        getOverdueSummary(startDate, endDate,commonFilter?.nbfc ?? "", resolve, reject);
      })
        .then((response) => {
          if (response?.status == 200 && response?.message == "success") {
            setOverdueSummaryData(response);
          } else {
            setOverdueSummaryData(null)
          }
        })
        .catch((e) => {
          setOverdueSummaryData(null)
          console.error("Failed to fetch overdue summary:", e);
        });
      setTimeout(() => {
        setLoader(false)
      }, 300)
    }
  }, [selectedMonths]);

  const currentData =
    selectedMonths.length > 0
      ? getDataForMonth(selectedMonths[0])
      : getDataForMonth("Apr 2026");

  // Map API alerts to component format
  const mappedAlerts = overdueSummaryData?.data?.alerts?.map((alert) => ({
    title: alert.metricName,
    trend: alert.direction.toLowerCase(),
    percent: `${Math.abs(alert.deviationPct).toFixed(1)}%`,
    description: alert.message,
  })) || [];

  // Use API data if available, otherwise use dummy data
  const alertData = mappedAlerts.length > 0 ? mappedAlerts : currentData.alerts || [];
  const summaryCards = overdueSummaryData?.data
    ? [
      {
        label: "Overdue Amount",
        value: overdueSummaryData.data.overdueAmountDisplay || "₹0",
        overallValue: overdueSummaryData.data.overdueAmount || "₹0",
        color: "#155DFC",
        bg: "#EFF6FF",
      },
      {
        label: "Projected Collection",
        value: overdueSummaryData.data.projectedCollectionDisplay || "₹0",
        overallValue: overdueSummaryData.data.projectedCollection || "₹0",
        color: "#16a34a",
        bg: "#f0fdf4",
      },
      {
        label: "Promise to Pay",
        value: overdueSummaryData.data.promiseToPayDisplay || "₹0",
        overallValue: overdueSummaryData.data.promiseToPay || "₹0",
        color: "#d97706",
        bg: "#fefce8",
      },
    ]
    : currentData.financial
      ? [
        {
          label: "Overdue Amount",
          value: `₹${currentData.financial.overdueAmount}`,
          color: "#155DFC",
          bg: "#EFF6FF",
        },
        {
          label: "Projected Collection",
          value: `₹${currentData.financial.projectedCollection}`,
          color: "#16a34a",
          bg: "#f0fdf4",
        },
        {
          label: "Promise to Pay",
          value: `₹${currentData.financial.promiseToPay}`,
          color: "#d97706",
          bg: "#fefce8",
        },
      ]
      : [];

  const handleTagKeyDown = (e, idx) => {
    if (e.key === "Enter" && tagInputs[idx].trim()) {
      setTags((prev) => ({
        ...prev,
        [idx]: [...prev[idx], tagInputs[idx].trim()],
      }));
      setTagInputs((prev) => ({ ...prev, [idx]: "" }));
    }
  };

  return (
    <div className="mis-main">
      {
        loader ? <Loader /> : ""
      }
      <div
        style={{
          background: "linear-gradient(135deg, #2563eb 0%, #7c3aed 50%, #a855f7 100%)",

          padding: "28px 32px",
        }}
      >
        <h1
          style={{
            margin: "0 0 6px",
            fontSize: "26px",
            fontWeight: 700,
            color: "#ffffff",
            letterSpacing: "-0.3px",
            display: 'inline-flex',
            gap: '5px',
            cursor: 'pointer'
          }}
          onClick={(e) => pageViewHandler(e, "landingPage")}
        >
          <ChevronLeft style={{ width: 'auto' }} /> Financial MIS Dashboard
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "15px",
            color: "rgba(255, 255, 255, 0.82)",
            fontWeight: 400,
          }}
        >
          Advanced Collection, Disbursal &amp; Financial Analytics
        </p>
      </div>
      <div
        className="container-fluid"
        style={{
          // padding: "20px 40px",
          minHeight: "100vh",
          backgroundColor: "#f8fafa",
          fontFamily: "system-ui, -apple-system, sans-serif",

          padding: window.innerWidth > 1800 ? "40px 70px 0 70px" : "",
          // maxWidth: "1400px",
          // margin: "10px auto 0",
        }}
      >

        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            padding: "28px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "24px",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <h1
              style={{
                margin: 0,
                fontSize: "clamp(15px, 1.8vw, 18px)",
                fontWeight: "600",
                color: "#1e293b",
              }}
            >
              Select Month(s)
            </h1>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexWrap: "wrap",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "relative",
                  border: "1px solid #FEF2F2",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  backgroundColor: "#FEF2F2",
                  color: "#E7000B",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: "clamp(12px, 1.2vw, 14px)",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    backgroundColor: "#E7000B",
                    color: "#fff",
                    borderRadius: "50%",
                    width: "18px",
                    height: "18px",
                    fontSize: "clamp(10px, 0.8vw, 11px)",
                    fontWeight: "700",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {alertData ? alertData.length : 0}
                </span>
                <TriangleAlert size={16} color="#E7000B" />

                <div onClick={() => setActivePanel("alerts")}>Alerts</div>
              </div>

              <div
                onClick={() => setActivePanel("comments")}
                style={{
                  border: "1px solid #EFF6FF",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  backgroundColor: "#EFF6FF",
                  color: "#1e293b",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: "clamp(12px, 1.2vw, 14px)",
                  cursor: "pointer",
                }}
              >
                <MessageSquare size={16} color="#155DFC" />
                Comments
              </div>

              <div
                onClick={() => setActivePanel("reminders")}
                style={{
                  border: "1px solid #FAF5FF",
                  padding: "8px 14px",
                  borderRadius: "8px",
                  backgroundColor: "#FAF5FF",
                  color: "#1e293b",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: "clamp(12px, 1.2vw, 14px)",
                  cursor: "pointer",
                }}
              >
                <Bell size={16} color="#9810FA" />
                Reminders
              </div>
            </div>
          </div>


          <CustomDateScroll
            selectedMonths={selectedMonths}
            setSelectedMonths={setSelectedMonths}
          />
          {
            selectedMonths.length > 0 ?
              <div
                style={{


                  // padding: '10px 15px',
                  // background: "rgb(249, 250, 251)",
                  boxSizing: "border-box",
                  borderRadius: "16px",
                  // border: "1px solid rgb(226, 232, 240)",
                  // boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                  margin: "30px 0",
                  display: 'flex', gap: '10px'
                }}
              >
                <div style={{ display: 'flex', gap: '10px', alignItems: 'end' }}>
                  <div>
                    <label style={{ fontSize: '12px', fontWeight: '400' }}>Start Date</label>
                    <input
                      type="date"
                      style={{
                        borderRadius: "12px",
                        border: "1px solid rgb(226, 232, 240)",
                        padding: '10px',
                        background: "#fff",
                        display: 'block',
                        minWidth: window.innerWidth > 1800 ? "250px" : '200px'
                      }}
                      min={SelectedMonthsFromDate?.fromDate}
                      value={commonFilter?.fromDate}
                      onChange={(e) => setcommonFilter((prev) => ({ ...prev, "fromDate": e.target.value }))}
                    />
                  </div>
                  <div>
                    <h5 style={{ margin: "0px 0 15px 0 " }}>::</h5>
                  </div>
                  <div>
                    <label style={{ fontSize: '12px', fontWeight: '400' }}>End Date</label>
                    <input
                      type="date"
                      style={{
                        borderRadius: "12px",
                        border: "1px solid rgb(226, 232, 240)",
                        padding: '10px',
                        background: "#fff",
                        display: 'block',
                        minWidth: window.innerWidth > 1800 ? "250px" : '200px'
                      }}
                      min={SelectedMonthsFromDate?.fromDate}
                      max={SelectedMonthsFromDate?.toDate}
                      value={commonFilter?.toDate}
                      onChange={(e) => setcommonFilter((prev) => ({ ...prev, "toDate": e.target.value }))}
                    />
                  </div>
                  <div>
                    <label style={{ fontSize: '12px', fontWeight: '400' }}>NBFC</label>
                    <select
                      type="date"
                      style={{
                        borderRadius: "12px",
                        border: "1px solid rgb(226, 232, 240)",
                        padding: '10px',
                        background: "#fff",
                        display: 'block',
                        minWidth: window.innerWidth > 1800 ? "250px" : '200px'
                      }}

                      value={commonFilter?.nbfc}
                      onChange={(e) => setcommonFilter((prev) => ({ ...prev, "nbfc": e.target.value }))}
                    >
                      <option value={""}>Select NBFC</option>
                      {
                        nbfcData && nbfcData?.length > 0 ? nbfcData?.map((val, id) => {
                          return (
                            <option value={val?.nbfcId}>{val?.name}</option>
                          )
                        })
                          : ""}
                    </select>
                  </div>
                </div>

              </div>
              : ""}

          <CommonPanel
            open={activePanel === "comments"}
            onClose={() => setActivePanel(null)}
            title="Comments & Notes"
            placeholder="Add a comment..."
            data={comments}
            addItem={(c) => setComments([c, ...comments])}
            theme="blue"
          />

          <CommonPanel
            open={activePanel === "reminders"}
            onClose={() => setActivePanel(null)}
            title="Reminders & Follow-ups"
            placeholder="Add a reminder..."
            data={reminders}
            addItem={(c) => setReminders([c, ...reminders])}
            theme="purple"
          />

          {/* <CommonPanel
            open={activePanel === "alerts"}
            onClose={() => setActivePanel(null)}
            title="Alert Notes"
            placeholder="Add note..."
            data={alertsNotes}
            addItem={(c) => setAlertsNotes([c, ...alertsNotes])}
            theme="red"
          /> */}
          {/* Alert Cards */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginBottom: "24px",
              borderBottom: '1px solid #eee'
            }}
          >
            {alertData.map((alert, idx) => (
              <div
                key={idx}
                style={{
                  backgroundColor: "#FEF2F2",
                  border: "1px solid #fee2e2",
                  borderLeft: "5px solid #E7000B",
                  borderRadius: "10px",
                  padding: "16px 20px",
                }}
              >
                {/* Title Row */}
                <div
                  style={{
                    display: "inline-flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "6px",
                    marginBottom: "6px",
                    padding: "10px",
                    width: "fit-content",
                  }}
                >
                  <TriangleAlert size={16} color="#E7000B" />
                  <span
                    style={{
                      color: "#82181A",
                      fontSize: "clamp(14px, 1.6vw, 16px)",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {alert.title}
                  </span>
                  {alert.trend === "up" ? (
                    <TrendingUp size={13} color="#E7000B" />
                  ) : (
                    <TrendingDown size={13} color="#00A63E" />
                  )}
                  <span
                    style={{
                      fontSize: "clamp(10px, 0.9vw, 12px)",
                      color: alert.trend === "up" ? "#E7000B" : "#00A63E",
                      fontWeight: "500",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {alert.percent}
                  </span>
                </div>

                {/* Description */}
                <p
                  style={{
                    margin: "0 0 10px 22px",
                    fontSize: "clamp(11px, 0.9vw, 13px)",
                    color: "#E7000B",
                  }}
                >
                  {alert.description}
                </p>

                {/* Tags */}
                {tags[idx].length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "6px",
                      marginBottom: "8px",
                      marginLeft: "22px",
                    }}
                  >
                    {tags[idx].map((tag, ti) => (
                      <span
                        key={ti}
                        style={{
                          backgroundColor: "#fee2e2",
                          color: "#E7000B",
                          borderRadius: "4px",
                          padding: "2px 8px",
                          fontSize: "clamp(10px, 0.8vw, 12px)",
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}

                {/* Tag Input */}
                <input
                  type="text"
                  placeholder="Add tag and press Enter..."
                  value={tagInputs[idx]}
                  onChange={(e) =>
                    setTagInputs((prev) => ({ ...prev, [idx]: e.target.value }))
                  }
                  onKeyDown={(e) => handleTagKeyDown(e, idx)}
                  style={{
                    marginLeft: "22px",
                    width: "300px",
                    padding: "7px 12px",
                    borderRadius: "6px",
                    border: "1px solid #D1D5DC",
                    backgroundColor: "rgb(254, 242, 242)",
                    fontSize: "clamp(11px, 0.9vw, 13px)",
                    color: "#64748b",
                    outline: "none",
                  }}
                />
              </div>
            ))}

            <p
              style={{
                margin: "0 0 24px 0",
                fontSize: "clamp(12px, 1.2vw, 14px)",
                color: "#64748b",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {selectedMonths.length > 0
                ? `Viewing: ${selectedMonths.join(", ")}`
                : "No months selected"}
            </p>


          </div>

          <h2
            style={{
              margin: "0 0 16px 0",
              fontSize: "clamp(14px, 1.6vw, 16px)",
              fontWeight: "500",
              color: "#1e293b",
            }}
          >
            Financial Summary for Selected Period
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "16px",
            }}
          >
            {summaryCards.map((card, idx) => (
              <div
                key={idx}
                style={{
                  backgroundColor: card.bg,
                  borderRadius: "10px",
                  padding: "20px 24px",
                }}
              >
                <div
                  style={{
                    fontSize: "clamp(12px, 1.2vw, 14px)",
                    color: "#64748b",
                    marginBottom: "8px",
                  }}
                >
                  {card.label}
                </div>
                <StyledTooltip
                  value={card?.overallValue}
                >
                  <div
                    style={{
                      fontSize: "clamp(22px, 3vw, 26px)",
                      fontWeight: "700",
                      color: card?.color,
                    }}
                  >
                    {card.value}
                  </div>
                </StyledTooltip>
              </div>
            ))}
          </div>
        </div>
        <div style={{ marginTop: "20px" }}>
          <MISnavbar onSelect={setSelectedView}></MISnavbar>
        </div>

        <div style={{ paddingBottom: '20px' }}>
          {selectedMonths.length > 0 ? (
            <>
              {selectedView === "disbursal" && (
                <DisbursalTracking selectedMonth={selectedMonths} commonFilter={commonFilter} />
              )}

              {selectedView === "financial" && (
                <Financial selectedMonth={selectedMonths} commonFilter={commonFilter} />
              )}

              {selectedView === "funnel" && (
                <FunnelVisualization selectedMonth={selectedMonths} commonFilter={commonFilter} />
              )}

              {selectedView === "emi" && (
                <EmiBehavour selectedMonth={selectedMonths} commonFilter={commonFilter} />
              )}

              {selectedView === "projection" && (
                <ProjectVSActual selectedMonth={selectedMonths} commonFilter={commonFilter} />
              )}
            </>
          ) : (
            <div
              style={{
                padding: "40px",
                textAlign: "center",
                color: "#94a3b8",
              }}
            >
              Please select at least one month
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
